import { Flex, Skeleton, Grid } from "@chakra-ui/react";

export const SkeletonTema = () => {
    return (
        <Flex
            direction="column"
            w="100%"
            gap="20px"
        >
            <Flex direction="column" gap="10px">
                <Skeleton
                    h="35px"
                    w="150px"
                    rounded="5px"
                />

                <Skeleton
                    h="25px"
                    w="100px"
                    rounded="5px"
                />

                <Flex
                    gap="10px"
                    alignItems="center"
                    mt="10px"
                >
                    {[0, 1].map((tag: any) => (
                        <Skeleton
                            key={tag}
                            h="30px"
                            w="80px"
                            rounded="100px"
                        />
                    ))}
                </Flex>
            </Flex>

            <Flex
                gap="40px"
            >
                <Flex
                    w="1237px"
                    direction="column"
                    gap="20px"
                >
                    <Grid
                        w="100%"
                        gap="40px"
                        gridTemplateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }}
                    >
                        {[{}, {}, {}, {}, {}, {}].map((_item: any, index: number) => (
                            <Skeleton
                                key={index}
                                w="100%"
                                h="300px"
                                rounded="5px"
                                boxShadow="0px 3.5px 5.5px 0px rgba(0, 0, 0, 0.02)"
                                transition=" 0.3s ease-in-out, box-shadow 0.3s ease-in-out"
                            />
                        ))}
                    </Grid>
                </Flex>
            </Flex>
        </Flex>
    );
}